import React, {useState} from 'react'
import {Flex} from "reflexbox";
import Drawer from "@mui/material/Drawer";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {Bookmark, Chat, Code, DarkMode, Delete, Description, EmojiEvents, LightMode, Settings} from "@mui/icons-material";
import * as route from "../helpers/routes";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import AlertDialog from "../common/AlertDialog";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Switch from "@mui/material/Switch";
import { useColorMode } from "../helpers/ColorModeContext";
import { isDev } from "../helpers/misc";


const SettingsMenu = () => {
  let navigate = useNavigate();
  const platform = useSelector((state) => state.platform);
  const [drawer, toggleDrawer] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const { mode, toggleColorMode } = useColorMode();

  const menuItems = [
    {
      name: 'Intro at launch',
      icon: <Bookmark/>,
      link: route.GAMEOVERVIEW,
    },
    {
      name: 'Leaderboards',
      icon: <EmojiEvents/>,
      link: route.LEADERBOARD,
    },
    {
      name: 'Delete my data',
      icon: <Delete/>,
      link: route.DELETEMYDATA,
    },
    {
      name: 'Privacy Policy',
      icon: <Description/>,
      link: route.PRIVACYPOLICY,
    },
    {
      name: 'Contact us',
      icon: <Chat/>,
      link: route.FEEDBACK,
    },
    {
      name: 'Developer test mode',
      icon: <Code/>,
      specialFunc: () => setDialog(true),
    },
  ];
  const handleContinue = () => {
    if (password === 'asdf') {
      navigate(route.TEST);
      setDialog(false)
    } else {
      setError(true)
    }
  };

  return (<div style={{ maxWidth: '62px' }}>
      <IconButton
        aria-label="Open settings"
        onClick={() => toggleDrawer(!drawer)}
        size="large"
        sx={{ color: 'text.secondary' }}
      >
        <Settings />
      </IconButton>

      <Drawer anchor={'right'} open={drawer} onClose={() => toggleDrawer(!drawer)}>
        <Flex style={{flexDirection: 'column', paddingTop: platform.statusBarHeight}}>
          <List>
            {menuItems.map((value, key) => (
              <ListItem key={key} style={{ padding: '16px'}} onClick={() => {
                if (value.specialFunc) {
                  value.specialFunc()
                } else {
                  navigate(value.link);
                }
              }}>
                <ListItemIcon>{value.icon}</ListItemIcon>
                <ListItemText>{value.name}</ListItemText>
              </ListItem>)
            )}
            <ListItem style={{ padding: '8px 16px' }}>
              <ListItemIcon>
                {mode === 'dark' ? <DarkMode /> : <LightMode />}
              </ListItemIcon>
              <ListItemText primary="Dark mode" />
              <ListItemSecondaryAction>
                <Switch
                  edge="end"
                  checked={mode === 'dark'}
                  onChange={toggleColorMode}
                  inputProps={{ 'aria-label': 'Dark mode' }}
                />
              </ListItemSecondaryAction>
            </ListItem>
          </List>
          <Typography id={'copy write notice'} variant={'caption'} color="text.secondary" sx={{ margin: '0 16px' }}>© Capital Clues, {new Date().getFullYear()}</Typography>
          {isDev && (
            <Typography variant="caption" color="warning.main" sx={{ margin: '4px 16px 16px' }}>
              This is DEV mode
            </Typography>
          )}
        </Flex>
      </Drawer>

      <AlertDialog open={dialog} close={() => setDialog(false)}
                   hideContinue
                   disableCancel
                   body={(<Flex style={{flexDirection: 'column'}}>
                     <TextField id="outlined-basic" label="Password:"
                                onChange={(e) => {
                                  error && setError(false)
                                  setPassword(e.target.value)
                                }}
                                variant="outlined"
                                style={{marginTop: '20px', width: '100%'}}/>
                     {error && <Typography variant="caption" color={'secondary'}>'Incorrect. Try again'</Typography>}
                     <Button onClick={handleContinue}
                             color={'primary'}
                             disabled={!password}
                             style={{marginTop: '16px'}}
                             variant={'contained'}>Submit</Button>

                   </Flex>)}
      />
    </div>
  )
}

export default SettingsMenu;